module.exports = __webpack_public_path__ + "media/images/top/search/img_hero-4902d49d0c5ed0f4c106dfc50d0538a9.png";